<script setup>
import ScheduleTable from '@/components/widgets/ScheduleTable'
import {inject, onMounted, ref} from 'vue'
import axios from 'axios'
import {useRouter} from 'vue-router'
const router = useRouter()

const contentData = inject('contentData')

const events = ref([])
const days = ref([])
const times = ref([])

const daysURL = 'api/days'
const timesURL = 'api/times'
const eventsURL = 'api/events'

const props = defineProps({
    data: {
        type: Object,
        required: false,
    },
})

const backEndURL = process.env.VUE_APP_BACKEND_URL

onMounted(async () => {
    await parseData()
})

const getData = async url => {
    try {
        const res = await axios.get(`${backEndURL}/${url}`)
        return res.data
    } catch (err) {
        console.error(err)
    }
}

const parseData = async () => {
    const _days = await getData(daysURL)
    days.value = _days.map(day => day.formatted_date)

    const _times = await getData(timesURL)
    times.value = _times.map(time => time.formatted_time)

    const _events = await getData(eventsURL)
    events.value = _events.map(({time_slots, day, author, ...ev}) => ({
        ...ev,
        ref: `${time_slots[0].formatted_time} ${day.formatted_date}`,
        time: time_slots.map(({formatted_time}) => formatted_time),
        day: day.formatted_date,
        author: author.map(a => `${a.name}, ${a.affiliation}`),
    }))
}
</script>

<template>
    <div id="scheduler">
        <section class="bg-white bg-contain bg-center bg-no-repeat pb-10 sm:pb-16">
            <div
                v-if="props.data && props.data.initial_text.display"
                v-html="props.data.initial_text.content"></div>
            <div class="container mx-auto flex items-center justify-center px-4 pt-8 sm:px-6 sm:pt-10">
                <ScheduleTable :days="days" :times="times" :events="events" />
            </div>
        </section>
        <section
            v-if="props.data && props.data.details.display"
            v-html="props.data.details.content"></section>
    </div>
</template>

<style scoped></style>
